// default separator for working with array parameters from URLSearchParams().get()
export const URL_QUERY_ARRAY_JOINER = ' ';
